/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { validateChildren as p } from "../utils/index.mjs";
import i from "./base/ConfigurationComponent.mjs";
import { MapMarkerLayerTooltip as m } from "./MarkerLayerTooltip.mjs";
const e = (r) => /* @__PURE__ */ t.createElement(i, { type: "marker", ...r });
e.displayName = "MapMarkerLayer";
e.propTypes = {
  children: function(r, a, o) {
    return p(r, a, o, m);
  }
};
export {
  e as MapMarkerLayer
};
